/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var FeatureFlags = /** @class */ (function () {
    function FeatureFlags(providers) {
        this.providers = providers;
    }
    FeatureFlags.prototype.isFeatureEnabled = function (featureName, defaultValue) {
        var e_1, _a;
        var value = this.getFeatureFromLocalStorage(featureName);
        if (value != null) {
            return value;
        }
        if (this.providers) {
            try {
                for (var _b = __values(this.providers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var provider = _c.value;
                    var value_1 = provider.isFeatureEnabled(featureName, defaultValue);
                    if (value_1 !== undefined) {
                        return value_1;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return !!defaultValue;
    };
    FeatureFlags.prototype.getFeatureFromLocalStorage = function (featureName) {
        var value = localStorage.getItem("FEATURE_".concat(featureName));
        if (!value) {
            return null;
        }
        try {
            return !!JSON.parse(value);
        }
        catch (e) {
            console.warn("Could not parse feature ".concat(featureName, " value from local storage: ").concat(value), e);
            return null;
        }
    };
    return FeatureFlags;
}());
export { FeatureFlags };
